import React from 'react'

import gitimage from "../../images/Github Button Web.png";
import linkedinimage from "../../images/Linkedin Button Web.png";
import scimage from "../../images/Soundcloud Button Web.png";

function Socmedialinks() {
  return (
    <>
    <div className='social-media-icons-container'>
    <div className='sm-icons'>
    <ul className='sm-icons-list'>
      <li>
      <div className="linkedin-button-web">
    <a href='https://www.linkedin.com/in/andrejs-grocs-andrey-detochkin-ab2106141/' target="_blank">
    <img
        className="button-img" 
        alt=""
        src={linkedinimage}
      />
    </a> 
      
    </div>
      </li>

      <li>   <div className="github-button-web">
    <a href='https://github.com/AndrejsGrocs' target="_blank">
    <img
        className="button-img"
        alt=""
        src={gitimage}
      />
      </a>
     
    </div></li>
      <li>    <div className="soundcloud-button-web">
    <a href='https://soundcloud.com/andrey-detochkin' target="_blank">
    <img
        className="sc-button-img"
        alt=""
        src={scimage}
      />
    </a>
   
    </div></li>
    </ul>
 


 

    </div>
    </div>
  
    </>
  )
}

export default Socmedialinks